import { render, staticRenderFns } from "./TypeItem.vue?vue&type=template&id=796b3a1a&scoped=true"
import script from "./TypeItem.vue?vue&type=script&lang=ts"
export * from "./TypeItem.vue?vue&type=script&lang=ts"
import style0 from "./TypeItem.vue?vue&type=style&index=0&id=796b3a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796b3a1a",
  null
  
)

export default component.exports